// extracted by mini-css-extract-plugin
export default {"wrapper":"ReceiptPublicBanner_wrapper__Co2NK","list_links":"ReceiptPublicBanner_list_links__xrsUp"};